const partnerLogin = () => import('@/views/partner/login');
const partnerHome = () => import('@/views/partner/home');
const partnerPersonal = () => import('@/views/partner/personal');
const partnerAddClinic = () => import('@/views/partner/addClinic');
const partnerBindDevice = () => import('@/views/partner/bindDevice');
const partnerDeviceList = () => import('@/views/partner/deviceList');
const partnerSalesDeviceList = () => import('@/views/partner/salesDeviceList');
const partnerMyClinic = () => import('@/views/partner/myClinic');
const partnerMyTeam = () => import('@/views/partner/myTeam');
const partnerPartnerInfo = () => import('@/views/partner/partnerInfo');
const partnerFinance = () => import('@/views/partner/finance');
const partnerFinanceDetail = () => import('@/views/partner/financeDetail');
const partnerDeviceDetail = () => import('@/views/partner/deviceDetail');
const partnerReportDetail = () => import('@/views/partner/reportDetail');
const partnerClinicDetail = () => import('@/views/partner/clinicDetail');
const partnerClock = () => import('@/views/partner/clock');
const partnerInfoEdit = () => import('@/views/partner/infoEdit');
const partnerInfoEditAdd = () => import('@/views/partner/infoEditAdd');
const partnerInviteEdit = () => import('@/views/partner/inviteEdit');
const partnerInviteSuccess = () => import('@/views/partner/inviteSuccess');
const partnerClinicInfo = () => import('@/views/partner/clinicInfo');
const partnerClinicInfoEdit = () => import('@/views/partner/clinicInfoEdit');
const partnerMyPartner = () => import('@/views/partner/myPartner');
const partnerClinicOrder = () => import('@/views/partner/clinicOrder');
const partnerClinicOrderList = () => import('@/views/partner/clinicOrderList');
const partnerBuy = () => import('@/views/partner/buy');
const partnerOrderConfirm = () => import('@/views/partner/orderConfirm');
const partnerOrderDetail = () => import('@/views/partner/orderDetail');
const partnerMealDetail = () => import('@/views/partner/mealDetail');
const partnerMyOrder = () => import('@/views/partner/myOrder');
const partnerMyAddress = () => import('@/views/partner/myAddress');
const partnerAddressEdit = () => import('@/views/partner/addressEdit');
const partnerClinicInventory = () => import('@/views/partner/clinicInventory');
const partnerClinicPerformance = () => import('@/views/partner/clinicPerformance');
const partnerStockSales = () => import('@/views/partner/stockSales');
const partnerStockDeviceSales = () => import('@/views/partner/stockDeviceSales');
const partnerContractList = () => import('@/views/partner/contractList');
const partnerSalesStockRecord = () => import('@/views/partner/salesStockRecord');
const partnerDeviceApplyRecord = () => import('@/views/partner/deviceApplyRecord');
const partnerMaterialApplication = () => import('@/views/partner/materialApplication');
const partnerAddContract = () => import('@/views/partner/addContract');

export default [
  {
    path: '/partner-login',
    name: 'partnerLogin',
    component: partnerLogin,
    meta: { title: '登录', hideBack: true, noAuth: true }
  },
  {
    path: '/partner-home',
    name: 'partnerHome',
    component: partnerHome,
    meta: { title: '首页', hideBack: true }
  },
  {
    path: '/partner-personal',
    name: 'partnerPersonal',
    component: partnerPersonal,
    meta: {
      title: '我的',
      hideBack: true,
      keeps: ['subjectAnalyse', 'subjectLawerdetail']
    }
  },
  {
    path: '/partner-add-clinic',
    name: 'partnerAddClinic',
    component: partnerAddClinic,
    meta: {
      title: '添加诊所'
    }
  },
  {
    path: '/partner-bind-device',
    name: 'partnerBindDevice',
    component: partnerBindDevice,
    meta: {
      title: '绑定设备'
    }
  },
  {
    path: '/partner-my-team',
    name: 'partnerMyTeam',
    component: partnerMyTeam,
    meta: {
      title: '我的团队',
      hideBack: true
    }
  },
  {
    path: '/partner-partner-info',
    name: 'partnerPartnerInfo',
    component: partnerPartnerInfo,
    meta: {
      title: '业务员信息'
    }
  },
  {
    path: '/partner-finance',
    name: 'partnerFinance',
    component: partnerFinance,
    meta: {
      title: '业绩统计'
    }
  },
  {
    path: '/partner-finance-detail',
    name: 'partnerFinanceDetail',
    component: partnerFinanceDetail,
    meta: {
      title: '业绩详情'
    }
  },
  {
    path: '/partner-device-List',
    name: 'partnerDeviceList',
    component: partnerDeviceList,
    meta: {
      title: '设备列表'
    }
  },
  {
    path: '/partner-sales-device-List',
    name: 'partnerSalesDeviceList',
    component: partnerSalesDeviceList,
    meta: {
      title: '设备列表'
    }
  },
  {
    path: '/partner-device-detail',
    name: 'partnerDeviceDetail',
    component: partnerDeviceDetail,
    meta: {
      title: '设备详情'
    }
  },
  {
    path: '/partner-my-clinic',
    name: 'partnerMyClinic',
    component: partnerMyClinic,
    meta: {
      title: '我的诊所',
      keeps: ['partnerClinicInfo']
    }
  },
  {
    path: '/partner-report-detail',
    name: 'partnerReportDetail',
    component: partnerReportDetail,
    meta: {
      title: '报告详情'
    }
  },
  {
    path: '/partner-clinic-detail',
    name: 'partnerClinicDetail',
    component: partnerClinicDetail,
    meta: {
      title: '诊所详情'
    }
  },
  {
    path: '/partner-clock',
    name: 'partnerClock',
    component: partnerClock,
    meta: {
      title: '打卡'
    }
  },
  {
    path: '/partner-info-edit',
    name: 'partnerInfoEdit',
    component: partnerInfoEdit,
    meta: {
      title: '基本信息'
    }
  },
  {
    path: '/partner-info-edit-add',
    name: 'partnerInfoEditAdd',
    component: partnerInfoEditAdd,
    meta: {
      title: '基本信息'
    }
  },
  {
    path: '/partner-invite-edit',
    name: 'partnerInviteEdit',
    component: partnerInviteEdit,
    meta: {
      title: `诚邀您加入${process.env.VUE_APP_TITLE}`,
      hideBack: true,
      noAuth: true
    }
  },
  {
    path: '/partner-invite-success',
    name: 'partnerInviteSuccess',
    component: partnerInviteSuccess,
    meta: {
      title: '提交成功',
      hideBack: true,
      noAuth: true
    }
  },
  {
    path: '/partner-clinic-info',
    name: 'partnerClinicInfo',
    component: partnerClinicInfo,
    meta: {
      title: '诊所信息'
    }
  },
  {
    path: '/partner-clinic-info-edit',
    name: 'partnerClinicInfoEdit',
    component: partnerClinicInfoEdit,
    meta: {
      title: '诊所信息'
    }
  },
  {
    path: '/partner-my-partner',
    name: 'partnerMyPartner',
    component: partnerMyPartner,
    meta: {
      title: '诊所业务员'
    }
  },
  {
    path: '/partner-clinic-order',
    name: 'partnerClinicOrder',
    component: partnerClinicOrder,
    meta: {
      title: '诊所订单'
    }
  },
  {
    path: '/partner-clinic-order-list',
    name: 'partnerClinicOrderList',
    component: partnerClinicOrderList,
    meta: {
      title: '待出库'
    }
  },
  {
    path: '/partner-buy',
    name: 'partnerBuy',
    component: partnerBuy,
    meta: {
      title: '服务购买'
    }
  },
  {
    path: '/partner-order-confirm',
    name: 'partnerOrderConfirm',
    component: partnerOrderConfirm,
    meta: {
      title: '确认订单',
      keeps: ['partnerMyAddress']
    }
  },
  {
    path: '/partner-order-detail',
    name: 'partnerOrderDetail',
    component: partnerOrderDetail,
    meta: {
      title: '订单详情',
      keeps: ['partnerMyAddress']
    }
  },
  {
    path: '/partner-meal-detail',
    name: 'partnerMealDetail',
    component: partnerMealDetail,
    meta: {
      title: '商品详情'
    }
  },
  {
    path: '/partner-my-order',
    name: 'partnerMyOrder',
    component: partnerMyOrder,
    meta: {
      title: '我的订单'
    }
  },
  {
    path: '/partner-my-address',
    name: 'partnerMyAddress',
    component: partnerMyAddress,
    meta: {
      title: '我的收货地址',
      keeps: ['partnerOrderConfirm']
    }
  },
  {
    path: '/partner-address-edit',
    name: 'partnerAddressEdit',
    component: partnerAddressEdit,
    meta: {
      title: '编辑地址'
    }
  },
  {
    path: '/partner-clinic-inventory',
    name: 'partnerClinicInventory',
    component: partnerClinicInventory,
    meta: {
      title: '诊所库存'
    }
  },
  {
    path: '/partner-clinic-performance',
    name: 'partnerClinicPerformance',
    component: partnerClinicPerformance,
    meta: {
      title: '业绩分析',
      hideBack: true
    }
  },
  {
    path: '/partner-stock-sales',
    name: 'partnerStockSales',
    component: partnerStockSales,
    meta: {
      title: '业务员库存'
    }
  },
  {
    path: '/partner-sales-stock-record',
    name: 'partnerSalesStockRecord',
    component: partnerSalesStockRecord,
    meta: {
      title: '库存明细'
    }
  },
  {
    path: '/partner-device-apply-record',
    name: 'partnerDeviceApplyRecord',
    component: partnerDeviceApplyRecord,
    meta: {
      title: '设备申请记录'
    }
  },
  {
    path: '/partner-material-application',
    name: 'partnerMaterialApplication',
    component: partnerMaterialApplication,
    meta: {
      title: '申请设备'
    }
  },
  {
    path: '/partner-stock-device-sales',
    name: 'partnerStockDeviceSales',
    component: partnerStockDeviceSales,
    meta: {
      title: '业务员设备库存'
    }
  },
  {
    path: '/partner-contract-list',
    name: 'partnerContractList',
    component: partnerContractList,
    meta: {
      title: '合同列表'
    }
  },
  {
    path: '/partner-add-contract',
    name: 'partnerAddContract',
    component: partnerAddContract,
    meta: {
      title: '新增合同签约'
    }
  }
];
